import { TAP_LIMIT } from '../../../constants/AppConstants';
import Item, { SHIFT_UP_DESKTOP, SHIFT_UP_MOBILE } from './Item';
import { SIZE_GROUND } from './Item';

export default class Backpack extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isBackpack = true;
    this.itemsInside = [];
  }

  init(itemData) {
    this.isOpen = itemData.open;

    // this.items = [];
    // if (itemData && itemData.items) {
    //   this.items = itemData.items.concat();
    // }

    if (this.isOpen) {
      this.open();
    }

    // add initial items
    for (let i = 0; i < itemData.items.length; i++) {
      const item = this.location.addItem(itemData.items[i]);
      this.addItem(item, false);
    }

    super.init(itemData);
  }

  addItem(item, save = true) {
    item.disable();
    this.addChild(item);
    item.visible = false;
    item.x = 0;
    item.y = 0;

    item.container = this; // set reference to this container
    this.itemsInside.push(item);

    this.updateBounds();

    this.animateSquize();

    this.game.sounds.playSFX('item_combine', { spriteID: 'sfx' });

    //
    save && this.onChange.dispatch();
  }

  open() {
    this.isOpen = true;
    this.isContainer = true;

    this.frameName = this.frameName + '_open';
  }

  handleInputUp() {
    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.setScale(SIZE_GROUND);

    // check if it was moved
    const dx = this.pointer.x - this.startPos.x;
    const dy = this.pointer.y - this.startPos.y;
    const dist = Math.sqrt(dx * dx + dy * dy);

    this.pointer = null;

    if (dist < TAP_LIMIT && this.game.deviceMetric.platform.type !== 'desktop') {
      // fix position of movable items
      const dy =
        this.game.deviceMetric.platform.type === 'desktop' ? SHIFT_UP_DESKTOP : SHIFT_UP_MOBILE;
      this.y -= dy;

      //
      this.handleTap();
    }

    // drop item
    this.onDrop.dispatch(this);
  }

  handleTap() {
    if (!this.isOpen) {
      this.open();
    }
    // spawn items one by one
    // this.animateStretch();
    // this.game.time.events.add(150, this.spawnItem, this, this.x, this.y);

    this.animateStretch();
    this.game.time.events.add(150, this.emptyContainer, this);
  }

  emptyContainer() {
    if (this.itemsInside.length === 0) {
      return;
    }

    //
    const amount = Math.max(1, this.itemsInside.length - 1);
    const w = Math.min(150, amount * 30);
    const offset = w / amount;
    let x0 = this.x - w * 0.5;
    for (let i = 0; i < this.itemsInside.length; i++) {
      const item = this.itemsInside[i];
      item.enable();
      item.setScale(SIZE_GROUND);
      item.x = this.worldPosition.x - this.location.x;
      item.y = this.worldPosition.y;
      item.container = null;
      item.visible = true;
      const dx = offset * i + Phaser.Math.between(-5, 5);
      const dy = Phaser.Math.between(5, 30);
      const x = x0 + dx;
      const y = this.y + dy;
      this.location.addObjectToLocation(item);
      if (this.location.tryPutIntoPond(item)) {
        x0 = item.x - w * 0.5;
        item.animateToPosition(x0 + dx, item.y, 500, true);
      } else {
        item.animateToPosition(x, y);
        this.location.setDestinationPosition(item);
      }
    }
    this.itemsInside = [];

    this.location.addCloud({ x: this.x, y: this.y - this.height * 0.3, h: this.bb.height });

    this.game.sounds.playSFX('item_combine', { spriteID: 'sfx' });
  }

  canPutItem(item) {
    if (this.isOpen) {
      this.updateBounds();
      this.bb.x += -this.location.x;
      if (Phaser.Rectangle.contains(this.bb, item.x, item.y)) {
        this.bb.x += this.location.x;
        return true;
      }
      this.bb.x += this.location.x;
    }
    return false;
  }

  canHover() {
    return !this.drag && (!this.isOpen || this.itemsInside.length > 0);
  }

  //
  serialize() {
    const data = super.serialize();
    data.open = this.isOpen;
    // if (!this.isOpen) {
    //   data.items = this.items.concat();
    // } else {
    data.items = [];
    for (let i = 0; i < this.itemsInside.length; i++) {
      data.items.push(this.itemsInside[i].id);
    }
    // }
    return data;
  }
}
